import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  style: {
    "background": "#F7F8FA !important"
  }
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("   首页");

var _hoisted_3 = {
  key: 0,
  class: "order_div"
};
var _hoisted_4 = {
  class: "subject1"
};
var _hoisted_5 = {
  class: "liang_phonenumber1"
};

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-area1"
}, null, -1);

var _hoisted_7 = {
  class: "text1"
};
var _hoisted_8 = {
  class: "text1"
};
var _hoisted_9 = {
  key: 0,
  class: "text1"
};
var _hoisted_10 = {
  key: 1,
  class: "text1"
};
var _hoisted_11 = {
  key: 2,
  class: "text1"
};
var _hoisted_12 = {
  key: 3,
  class: "text1"
};
var _hoisted_13 = {
  key: 4,
  class: "text1"
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1,
  class: "packageTable"
};

var _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "开户套餐", -1);

var _hoisted_17 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "月费", -1);

var _hoisted_18 = {
  key: 0
};

var _hoisted_19 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "优惠", -1);

var _hoisted_20 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐内", -1);

var _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "套餐外", -1);

var _hoisted_22 = {
  key: 1
};

var _hoisted_23 = /*#__PURE__*/_createElementVNode("td", {
  class: "title"
}, "合约", -1);

var _hoisted_24 = {
  key: 0
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode("号码月保底消费");

var _hoisted_26 = {
  class: "red"
};

var _hoisted_27 = /*#__PURE__*/_createTextVNode("元");

var _hoisted_28 = {
  key: 1
};

var _hoisted_29 = /*#__PURE__*/_createTextVNode("号码要求在网时长");

var _hoisted_30 = {
  class: "red"
};

var _hoisted_31 = /*#__PURE__*/_createTextVNode("个月");

var _hoisted_32 = {
  key: 1,
  style: {
    "text-align": "center",
    "margin": "0.26rem",
    "font-size": "0.2rem"
  }
};
var _hoisted_33 = {
  style: {
    "text-align": "center",
    "margin": "0.26rem",
    "font-size": "0.2rem"
  }
};

var _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, " 扫一扫关注公众号，联系在线客服咨询更多订单信息 ", -1);

var _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "2rem"
  }
}, null, -1);

var _hoisted_37 = {
  style: {
    "font-size": "0.2rem"
  }
};

var _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", null, "请确认微信支付是否已经完成", -1);

var _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_40 = /*#__PURE__*/_createTextVNode("已完成支付");

var _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_43 = /*#__PURE__*/_createTextVNode("支付遇到问题，重新支付");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");

  var _component_van_nav_bar = _resolveComponent("van-nav-bar");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_collapse_item = _resolveComponent("van-collapse-item");

  var _component_van_collapse = _resolveComponent("van-collapse");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_image = _resolveComponent("van-image");

  var _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    style: {
      "width": "7.5rem",
      "margin": "0 auto"
    },
    title: "预约下单结果",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.goHome();
    })
  }, {
    left: _withCtx(function () {
      return [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.goHome && $options.goHome.apply($options, arguments);
        })
      }, [_createVNode(_component_van_icon, {
        name: "wap-home-o",
        size: "18"
      }), _hoisted_2])];
    }),
    _: 1
  }), $data.order != null ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.order.phoneNumber), 1), _hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString($data.order.pProvince), 1), _createElementVNode("span", _hoisted_8, _toDisplayString($data.order.pArea), 1), $data.order.optId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "中国移动")) : $data.order.optId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "中国联通")) : $data.order.optId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "中国电信")) : $data.order.optId == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "民营运营商")) : $data.order.optId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "中国广电")) : _createCommentVNode("", true)]), _createVNode(_component_van_cell_group, {
    inset: "",
    style: {
      "margin": "0.1rem"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell, {
        title: "下单时间",
        value: $data.order.createTime
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "开户人",
        value: $data.order.userName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "身份证号",
        value: $data.order.idCard
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "联系电话",
        value: $data.order.phone
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "收件地址",
        value: $data.order.postProvince + ' ' + $data.order.postCity + ' ' + $data.order.postArea + ' ' + $data.order.address
      }, null, 8, ["value"]), $data.order.expressNo != null ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: "物流单号",
        value: $data.order.expressComponey + ' ' + $data.order.expressNo
      }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_component_van_collapse, {
        modelValue: $data.activeNames,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $data.activeNames = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_collapse_item, {
            title: "订单金额",
            value: $data.order.needPayPrice + ' 元',
            name: "1",
            class: "value-red"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_cell, {
                title: "服务费",
                value: $data.order.needPayPrice - $data.order.advanceFee + ' 元'
              }, null, 8, ["value"]), _createVNode(_component_van_cell, {
                title: "话费",
                value: $data.order.advanceFee + ' 元'
              }, null, 8, ["value"])];
            }),
            _: 1
          }, 8, ["value"])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_cell, {
        title: "订单状态",
        value: $options.orderStatus(),
        class: "value-red"
      }, null, 8, ["value"]), $data.order.status == 4 ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 1,
        title: "失败原因",
        value: $data.order.apiRemark,
        class: "value-red"
      }, null, 8, ["value"])) : _createCommentVNode("", true), $data.leftTimeStr != null ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 2,
        title: "剩余支付时间",
        value: $data.leftTimeStr,
        class: "value-red"
      }, null, 8, ["value"])) : _createCommentVNode("", true)];
    }),
    _: 1
  }), $data.leftTimeStr != null ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_van_button, {
    round: "",
    size: "large",
    type: "success",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.wechatPay();
    }),
    disabled: $data.btnDisabled
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString($data.payBtnText), 1)];
    }),
    _: 1
  }, 8, ["disabled"])])) : _createCommentVNode("", true), $data.order.product != null ? (_openBlock(), _createElementBlock("table", _hoisted_15, [_createElementVNode("tr", null, [_hoisted_16, _createElementVNode("td", null, _toDisplayString($data.order.product.userProductName), 1)]), _createElementVNode("tr", null, [_hoisted_17, _createElementVNode("td", null, _toDisplayString($data.order.product.monthFee) + " 元/月", 1)]), $data.order.product.packageOther ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [_hoisted_19, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order.product.packageOther.split(/[;；]/), function (item, index) {
    return _openBlock(), _createElementBlock("p", {
      key: 'other_' + index
    }, _toDisplayString(item), 1);
  }), 128))])])) : _createCommentVNode("", true), _createElementVNode("tr", null, [_hoisted_20, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order.product.inPackageContent.split(/[;；]/), function (item, index) {
    return _openBlock(), _createElementBlock("p", {
      key: 'in_' + index
    }, _toDisplayString(item), 1);
  }), 128))])]), _createElementVNode("tr", null, [_hoisted_21, _createElementVNode("td", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order.product.outPackageFee.split(/[;；]/), function (item, index) {
    return _openBlock(), _createElementBlock("p", {
      key: 'out_' + index
    }, _toDisplayString(item), 1);
  }), 128))])]), $data.order.lowConsume && $data.order.lowConsume > 0 || $data.order.onlineMonths && $data.order.onlineMonths > 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [_hoisted_23, _createElementVNode("td", null, [$data.order.lowConsume != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString($data.order.lowConsume), 1), _hoisted_27])) : _createCommentVNode("", true), $data.order.onlineMonths != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_28, [_hoisted_29, _createElementVNode("span", _hoisted_30, _toDisplayString($data.order.onlineMonths), 1), _hoisted_31])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_32, " 未查询到相关订单 ")), _createElementVNode("div", _hoisted_33, [_createVNode(_component_van_image, {
    src: require('../assets/images/gzh.jpg')
  }, null, 8, ["src"]), _hoisted_34, _hoisted_35]), _hoisted_36, _createVNode(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
      return $data.show = $event;
    }),
    style: _normalizeStyle({
      padding: '0.2rem 0.8rem'
    }),
    "close-on-click-overlay": false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_37, [_hoisted_38, _hoisted_39, _createVNode(_component_van_button, {
        type: "success",
        size: "large",
        disabled: $data.resultBtnDisabled,
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $options.complatePay();
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_40];
        }),
        _: 1
      }, 8, ["disabled"]), _hoisted_41, _hoisted_42, _createVNode(_component_van_button, {
        type: "danger",
        size: "large",
        disabled: $data.resultBtnDisabled,
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return $options.wechatPay();
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_43];
        }),
        _: 1
      }, 8, ["disabled"])])];
    }),
    _: 1
  }, 8, ["show", "style"])]);
}